function isFiniteNumber(value)
{
    return typeof value === "number" && Number.isFinite(value);
}

export function roundMoney(value)
{
    const parsedValue = Number(value);

    if (!isFiniteNumber(parsedValue))
    {
        return null;
    }

    return Number(parsedValue.toFixed(2));
}

export function grossToNet19(value)
{
    const parsedValue = Number(value);

    if (!isFiniteNumber(parsedValue))
    {
        return null;
    }

    return roundMoney(parsedValue / 1.19);
}

export function getTrackingNetPrice(priceSource, isNetContext)
{
    const candidates = [
        priceSource && priceSource.unitPrice && priceSource.unitPrice.value,
        priceSource && priceSource.basePrice && priceSource.basePrice.value,
        priceSource && priceSource.price && priceSource.price.value,
        priceSource && priceSource.unitPrice,
        priceSource && priceSource.basePrice,
        priceSource && priceSource.price
    ];

    for (const candidate of candidates)
    {
        const parsedValue = Number(candidate);

        if (isFiniteNumber(parsedValue))
        {
            return isNetContext ? roundMoney(parsedValue) : grossToNet19(parsedValue);
        }
    }

    return null;
}

export function getTrackingPrice(priceSource)
{
    const candidates = [
        priceSource && priceSource.unitPrice && priceSource.unitPrice.value,
        priceSource && priceSource.basePrice && priceSource.basePrice.value,
        priceSource && priceSource.price && priceSource.price.value,
        priceSource && priceSource.unitPrice,
        priceSource && priceSource.basePrice,
        priceSource && priceSource.price
    ];

    for (const candidate of candidates)
    {
        const parsedValue = Number(candidate);

        if (isFiniteNumber(parsedValue))
        {
            return roundMoney(parsedValue);
        }
    }

    return null;
}

export function withOptionalPrice(payload, price)
{
    if (!isFiniteNumber(price))
    {
        return payload;
    }

    return {
        ...payload,
        price: roundMoney(price)
    };
}

export function withOptionalNetValue(payload, netValue)
{
    if (!isFiniteNumber(netValue))
    {
        return payload;
    }

    return {
        ...payload,
        value: roundMoney(netValue)
    };
}

export function getPurchaseNetValue(totalNet, totalGross, vatTotal)
{
    const parsedTotalNet = Number(totalNet);

    if (isFiniteNumber(parsedTotalNet))
    {
        return roundMoney(parsedTotalNet);
    }

    const parsedTotalGross = Number(totalGross);
    const parsedVatTotal = Number(vatTotal);

    if (isFiniteNumber(parsedTotalGross) && isFiniteNumber(parsedVatTotal))
    {
        return roundMoney(parsedTotalGross - parsedVatTotal);
    }

    return null;
}
